import { useCurrentStateAndParams } from "@uirouter/react";
import { useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import { selectIsRecentlyViewedOpportunityList } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import { OpportunityListVariant } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

import type { ListsDropdownButtonProps } from "../types";
import { StyledArrowIcon, StyledButtonText, StyledDropdownButton, StyledListIcon } from "./styles";

const DropdownButton = ({ list, onClick }: ListsDropdownButtonProps) => {
    const { variant, name, id } = list;
    const { params } = useCurrentStateAndParams();
    const isRecentlyViewedList = useSelector((state) => selectIsRecentlyViewedOpportunityList(state, id));

    return (
        <StyledDropdownButton onClick={onClick}>
            <StyledListIcon
                iconName={variant === OpportunityListVariant.Crm ? params.crm : "list-icon"}
                size="sm"
            />
            <StyledButtonText>
                {isRecentlyViewedList ? translate("si.opportunity-list.auto-created.title") : name}
            </StyledButtonText>
            <StyledArrowIcon iconName="arrow" />
        </StyledDropdownButton>
    );
};

export default DropdownButton;
